<template>
  <div class="defaul-footer">
    <div class="defaul-footer-t">
      <div class="defaul-footer-t-box">
        <img src="../../static/images/img22.jpg" />
        <img src="../../static/images/img23.jpg" />
        <img src="../../static/images/img24.jpg" />
        <img src="../../static/images/img22.jpg" />
        <img src="../../static/images/img23.jpg" />
        <img src="../../static/images/img23.jpg" />
        <img src="../../static/images/img24.jpg" />
        <img src="../../static/images/img22.jpg" />
      </div>
    </div>
    <div class="defaul-footer-b">
      <div class="defaul-footer-b-box">
        {{ detail.companyName }}&emsp;地址：{{ detail.companyAddr }}&emsp;电话：{{ detail.phone }}&emsp;{{
          detail.copyright
        }}
        <span v-html="detail.icp"></span>
      </div>
    </div>
    <!-- <div class="defaul-footer-text">
      <div>本网站由阿里云提供云计算及安全服务<p></p>
      </div>
      <div>本网站支持 <span>IPv6</span>
        <p></p> Powered by CloudDream
      </div>
    </div> -->
  </div>
</template>

<script>
import {infoList} from '@/api/xx-index'
export default {
  data() {
    return {
      detail: ''
    }
  },
  created() {
    this.infoListx()
  },
  methods: {
    infoListx() {
      infoList({deptId: 112}).then(res => {
        this.detail = res
        console.log(res)
      })
    }
  }
}
</script>

<style></style>
